import React from "react";
import propTypes from "prop-types";
import {
	cloudinarySourceSetAdapter,
	cloudinaryImageToSrcUrlAdapter,
	cloudinaryImageAdapter,
} from "../../sharedComponents/CloudinaryImageAdapter";
// eslint-disable-next-line import/no-cycle
import { MagazinePreviewBlock } from "./MagazinePreviewBlock";

const MagazinePreviewBlockConnector = ({ data }) => {
	const isIframeModal =
		data?.magazineModal?.componentType && data.magazineModal.componentType === "wedding-form";
	const content = isIframeModal && JSON.parse(data?.magazineModal.configuration?.internal?.content);

	return (
		<MagazinePreviewBlock
			blockImageCloudinary={{
				...cloudinaryImageAdapter({
					cloudinaryImage: data?.blockImageCloudinary?.[0],
					maxWidth: 600,
				}),
			}}
			sourceSet={cloudinarySourceSetAdapter(data.sourceSet)}
			blockImage={data?.blockImage?.file?.url}
			blockText={data?.blockText}
			magazineCoverImageCloudinaryUrl={cloudinaryImageToSrcUrlAdapter(
				data?.magazineCoverImageCloudinary?.[0]
			)}
			magazineLink={data?.magazineLink}
			magazineModal={content}
		/>
	);
};

MagazinePreviewBlockConnector.propTypes = {
	data: propTypes.shape({
		blockImageCloudinary: propTypes.arrayOf(
			propTypes.shape({
				secure_url: propTypes.string,
				format: propTypes.string,
				height: propTypes.number,
				public_id: propTypes.string,
				raw_transformation: propTypes.string,
				version: propTypes.number,
				width: propTypes.number,
			})
		),
		sourceSet: propTypes.arrayOf(
			propTypes.shape({
				cloudinaryAsset: propTypes.object,
				contentful_id: propTypes.string,
				id: propTypes.string,
				sourceSetDisplayedAt: propTypes.string,
				title: propTypes.string,
			})
		),
		blockImage: propTypes.shape({
			file: propTypes.shape({
				url: propTypes.string,
			}),
		}),
		blockText: propTypes.string,
		magazineCoverImageCloudinary: propTypes.arrayOf(
			propTypes.shape({
				secure_url: propTypes.string,
				format: propTypes.string,
				height: propTypes.number,
				public_id: propTypes.string,
				raw_transformation: propTypes.string,
				version: propTypes.number,
				width: propTypes.number,
			})
		),
		magazineLink: propTypes.shape({
			linkText: propTypes.string,
			url: propTypes.string,
			target: propTypes.string,
		}),
		magazineModal: propTypes.shape({
			componentType: propTypes.string,
			configuration: propTypes.shape({
				internal: propTypes.shape({
					content: propTypes.string,
				}),
			}),
		}),
	}),
};

MagazinePreviewBlockConnector.defaultProps = {
	data: null,
};

export default MagazinePreviewBlockConnector;
export { MagazinePreviewBlockConnector };
